import { render, staticRenderFns } from "./Menux.vue?vue&type=template&id=f6421c0e"
import script from "./Menux.vue?vue&type=script&lang=js"
export * from "./Menux.vue?vue&type=script&lang=js"
import style0 from "./Menux.vue?vue&type=style&index=0&id=f6421c0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports